import {
  AddMasterPlanRequest,
  Filter,
  GetLocationByIdAndEntityTypeRequest,
  GetMasterPlansRequest,
  Job,
  Location,
  MasterPlanFilterFields,
  MasterPlanFilterType,
  MasterPlanFilters,
  MasterPlanLocation,
  MasterPlanLocationFilter,
  PlanWithJobStateRequest,
  PrivateLocatioDetails,
  PublicLocation,
  VehicleGroup,
} from 'planning-portal-library/src/lib/core/domain';
import { PlanContainerLocationCount } from 'planning-portal-library/src/lib/core/domain/models/plan-container-location-count';
import { MapConfigurations } from '../../../map/model';
import { PlanContainerLocationCountByProduct } from 'planning-portal-library/src/lib/core/domain/models/plan-container-location-count-by-product';
import { LocationIds } from 'planning-portal-library/src/lib/core/domain/models/locations-Ids';
import { PlanJobDetails } from 'planning-portal-library/src/lib/core/domain/models/plan-job-details';
import { BaseRequest } from 'planning-portal-library/src/lib/data/shared/base.request';
import { TimeZones } from 'planning-portal-library/src/lib/core/domain/models/time-zones';
import { Weekday } from 'planning-portal-library/src/lib/core/domain/models/week-days';
import { LocationGroupFilterForPlanContainer } from 'planning-portal-library/src/lib/core/domain/models/location-group-filter-for plan-container';
import { VehicleGroupDto } from 'planning-portal-library/src/lib/core/domain/requests/vehicle-group/create-edit-vehicle-group-request';
import { LocationGroup } from 'planning-portal-library/src/lib/core/domain/models/location-group';
import { AnyGeometry } from 'planning-portal-library/src/lib/core/domain/models/map/geoJson/geometryTypes';
import { GLSLocation } from 'planning-portal-library/src/lib/core/domain/models/gls-location';
import { PublicLocationSequenceUpdateRequest } from 'planning-portal-library/src/lib/core/domain/models/public-location-job-sequence-update';

export class IsNewPlanCreated {
  static readonly type = '[NewEditMasterPlan] Is Plan Created';

  constructor(public payload: boolean | undefined) {}
}
export class IsEditMode {
  static readonly type = '[NewEditMasterPlan] Is Edit Mode';

  constructor(public payload: boolean | undefined) {}
}

export class AddMasterPlan {
  static readonly type = '[NewEditMasterPlan] Add Master Plan';

  constructor(public payload: AddMasterPlanRequest | undefined) {}
}

export class GetLocationsCount {
  static readonly type = '[NewEditMasterPlan] Get Locations Count';

  constructor(public payload: PlanContainerLocationCount | undefined) {}
}
export class GetLocationsCountByProduct {
  static readonly type = '[NewEditMasterPlan] Get Locations Count By Product';

  constructor(
    public payload: PlanContainerLocationCountByProduct | undefined
  ) {}
}

export class SetPublicLocations {
  static readonly type = '[NewEditMasterPlan] Set Public Locations';

  constructor(public payload: PublicLocation[] | undefined) {}
}

export class IsLocationAddedToMasterPlan {
  static readonly type = '[NewEditMasterPlan] Is Location Added To MasterPlan';

  constructor(public payload: boolean | undefined) {}
}

export class SetMasterPlanLocations {
  static readonly type = '[NewEditMasterPlan] Set Master Plan Locations';

  constructor(public payload: MasterPlanLocation[] | undefined) {}
}

export class SetMasterPlanId {
  static readonly type = '[NewEditMasterPlan] Set MasterPlan Id';

  constructor(public payload: string | undefined) {}
}

export class SetTimeZones {
  static readonly type = '[NewEditMasterPlan] Set Time Zones';

  constructor(public payload: TimeZones[] | undefined) {}
}

export class SetTimeZone {
  static readonly type = '[NewEditMasterPlan] Set Time Zone';

  constructor(public payload: string | undefined) {}
}
export class SetPlanDetails {
  static readonly type = '[NewEditMasterPlan] Set Plan Details';

  constructor(public payload: boolean | undefined) {}
}

export class SetTabIndex {
  static readonly type = '[NewEditMasterPlan] Set Tab Index';

  constructor(public payload: number | undefined) {}
}
export class SetIsImportVehicleOptionsVisible {
  static readonly type = '[NewEditMasterPlan] Set Import Vehicle Options';

  constructor(public payload: boolean | undefined) {}
}
export class SetPlanWithJobRequest {
  static readonly type = '[NewEditMasterPlan] Set Plan With Job Request';

  constructor(public payload: PlanWithJobStateRequest | undefined) {}
}

export class IsLocationDetailShow {
  static readonly type = '[NewEditMasterPlan] Is Location Detail Show';

  constructor(public payload: boolean | undefined) {}
}

export class IsUnassignedLocationShow {
  static readonly type = '[NewEditMasterPlan] Is Unassigned Show';

  constructor(public payload: boolean) {}
}

export class SetSelectedGroupIdForMLSImport {
  static readonly type = '[Base] Set Selected Group Id';

  constructor(public payload: string | undefined) {}
}

export class isRouteLocationDetailshow {
  static readonly type = '[NewEditMasterPlan] Is Route Location Detail Show';

  constructor(public payload: boolean | undefined) {}
}

export class SetSelectedLocationId {
  static readonly type = '[NewEditMasterPlan] Set Selected Location Id';

  constructor(
    public payload: GetLocationByIdAndEntityTypeRequest | undefined
  ) {}
}

export class SetSelectedLocation {
  static readonly type = '[NewEditMasterPlan] Set Selected Location';

  constructor(public payload: Location | undefined) {}
}

export class IsLocationUpdated {
  static readonly type = '[NewEditMasterPlan] Is Location Updated';

  constructor(public payload: boolean | undefined) {}
}

export class IsLocationsReImported {
  static readonly type = '[NewEditMasterPlan] Is Locations ReImported';

  constructor(public payload: boolean | undefined) {}
}

export class SetLocationGroupFilters {
  static readonly type = '[NewEditMasterPlan] Set Master Plan Location Filters';

  constructor(public payload: LocationGroup | undefined) {}
}

export class SetMapConfigurations {
  static readonly type = '[NewEditMasterPlan] Update Map';

  constructor(public payload: MapConfigurations | undefined) {}
}
export class SetPrivateLocationDetails {
  static readonly type = '[NewEditMasterPlan] Set Private Location Details';

  constructor(public payload: PrivateLocatioDetails | undefined) {}
}
export class RemovedUntitledPlan {
  static readonly type = '[NewEditMasterPlan] Remove Untitled Plan';

  constructor(public payload: boolean | undefined) {}
}

export class SetSelectedJob {
  static readonly type = '[NewEditMasterPlan] Set Selected Job';

  constructor(public payload: Job | undefined) {}
}
export class SetSearchParam {
  static readonly type = '[NewEditMasterPlan] Set Search Param';

  constructor(public payload: string | undefined) {}
}
export class IsAddEditJobShow {
  static readonly type = '[NewEditMasterPlan] Is Add Edit Job Show';

  constructor(public payload: boolean | undefined) {}
}
export class SetUnassignedLocations {
  static readonly type = '[NewEditMasterPlan] Set Unassigned Locations';

  constructor(public payload: Location[] | undefined) {}
}

export class IsEditJob {
  static readonly type = '[NewEditMasterPlan] Is Edit Job';

  constructor(public payload: boolean | undefined) {}
}
export class IsJobCreated {
  static readonly type = '[NewEditMasterPlan] Is Job Created';

  constructor(public payload: boolean | undefined) {}
}

export class SetPlanLocations {
  static readonly type = '[NewEditMasterPlan] Set Plan Locations';

  constructor(public payload: Location[] | undefined) {}
}

export class SetLocationsIdsBySegmentId {
  static readonly type = '[NewEditMasterPlan] Set Locations Ids By segment';

  constructor(public payload: LocationIds[] | undefined) {}
}
export class IsInjectLocationInPlan {
  static readonly type = '[NewEditMasterPlan] Is Inject Location In Plan';

  constructor(public payload: boolean | undefined) {}
}
export class GetPlanJobDetails {
  static readonly type = '[NewEditMasterPlan] Get Plan Job Details';

  constructor(public payload: PlanJobDetails | undefined) {}
}
export class IsCreateNewPlan {
  static readonly type = '[NewEditMasterPlan] Is Create New Plan';

  constructor(public payload: boolean | undefined) {}
}

export class IsImportLocationFromCSV {
  static readonly type = '[NewEditMasterPlan] Is Import Location From CSV';

  constructor(public payload: boolean | undefined) {}
}
export class SetNumberOfLocationGroups {
  static readonly type = '[NewEditMasterPlan] set number of location groups';

  constructor(public payload: number | undefined) {}
}

export class SetLocationGroupsForMap {
  static readonly type =
    '[NewEditMasterPlan] set location groups for map rendering';

  constructor(public payload: LocationGroup[] | undefined) {}
}

export class IsAddLocationManually {
  static readonly type = '[NewEditMasterPlan] Is Add Location Manually';

  constructor(public payload: boolean | undefined) {}
}
export class IsCalledFromMasterPlan {
  static readonly type = '[NewEditMasterPlan] Is called from Master Plan';

  constructor(public payload: boolean | undefined) {}
}

export class SetMasterPlanGridRequest {
  static readonly type = '[NewEditMasterPlan] Set Master Plan Grid Request';

  constructor(public payload: any | undefined) {}
}

export class GetMLSFilters {
  static readonly type = '[NewEditMasterPlan] Get MLS Filters';

  constructor(public payload: Filter[] | undefined) {}
}
export class GetFilters {
  static readonly type = '[NewEditMasterPlan] Get Filters';

  constructor(public payload: MasterPlanFilters[] | undefined) {}
}

export class GetFilterFields {
  static readonly type = '[NewEditMasterPlan] Get Filter Fields';

  constructor(public payload: MasterPlanFilterFields[] | undefined) {}
}

export class GetFilterType {
  static readonly type = '[NewEditMasterPlan] Get Filter Typer';

  constructor(public payload: MasterPlanFilterType[] | undefined) {}
}
export class GetVehicleGroup {
  static readonly type = '[NewEditMasterPlan] Get Vehicle Group';
  constructor(public payload: VehicleGroupDto[] | undefined) {}
}

export class IsFormTouched {
  static readonly type = '[NewEditMasterPlan] Is Form Touched';

  constructor(public payload: boolean | undefined) {}
}

export class SetWeekdays {
  static readonly type = '[NewUpdatePlanDetails] Set Weekdays';

  constructor(public payload: Weekday[] | undefined) {}
}

export class IsPlansPanelCollapsed {
  static readonly type = '[NewEditMasterPlan] Is Plans Panel Collapsed';

  constructor(public payload: boolean | undefined) {}
}

export class IsHDPlansPanelCollapsed {
  static readonly type = '[NewEditMasterPlan] Is HD Plans Panel Collapsed';

  constructor(public payload: boolean | undefined) {}
}

export class IsHDJobsPanelCollapsed {
  static readonly type = '[NewEditMasterPlan] Is HD Jobs Panel Collapsed';

  constructor(public payload: boolean | undefined) {}
}

export class IsMasterPanelCollapsed {
  static readonly type = '[NewEditMasterPlan] Is Master Panel Collapsed';

  constructor(public payload: boolean | undefined) {}
}

export class EnableSourceCard {
  static readonly type = '[NewEditMasterPlan] Enable Source Card';

  constructor(public payload: string | undefined) {}
}

export class ViewCardSettings {
  static readonly type = '[NewEditMasterPlan] View Card Settings';

  constructor(public payload: string | null) {}
}

export class LocationsCardSettings {
  static readonly type = '[NewEditMasterPlan] Location Card Settings';

  constructor(public payload: string | null) {}
}

export class SelectedMasterPlanType {
  static readonly type = '[NewEditMasterPlan] Selected Master Plan Type';
  constructor(public payload: number | undefined) {}
}

export class LocationsImported {
  static readonly type = '[NewEditMasterPlan] locations imported';
  constructor(public payload: boolean | undefined) {}
}

export class LocationsUpdated {
  static readonly type = '[NewEditMasterPlan] locations updated';
  constructor(
    public payload: PublicLocationSequenceUpdateRequest[] | undefined
  ) {}
}

export class ReCalculateSequence {
  static readonly type = '[NewEditMasterPlan] recalculate sequence';
  constructor(public payload: GLSLocation[] | undefined) {}
}

export class RenderMap {
  static readonly type = '[NewEditMasterPlan] render map';
  constructor(public payload: GLSLocation[][] | undefined) {}
}
export class RenderLocationMap {
  static readonly type = '[NewEditMasterPlan] render location map';
  constructor(public payload: GLSLocation[][] | undefined) {}
}
